export default "__VITE_ASSET__BvzT2Mf4__"